import { parseISO, format } from 'date-fns';

export const formatDate = (date: string) =>
  format(parseISO(date), "MMM d, yyyy 'at' h:mm a");

export const formatDateTime = (date: string) =>
  format(parseISO(date), 'MMM d, yyyy h:mm a');
